module.exports = __webpack_public_path__ + "static/media/alert_0.0dfef2ca.svg";